module.exports = __webpack_public_path__ + "static/img/head.4ec3a5bd.png";